import { useState } from "react"
import styles from "./AppointmentDetailsTableHeadCellCard.module.css"
import ArrowUpIcon from "@assets/icons/arrowUp"
const PatientDetailsTableHeadCellCard = ({
  name,
  setShowFilters,
  setFilterToBeExpanded,
  sortPath,
  setPaginationState,
}) => {
  const [showDropDown, setShowDropDown] = useState(false)

  const handleSorting = (event) => {
    if (setPaginationState) {
      const order = event.currentTarget.getAttribute("data-order")
      setPaginationState((previous) => {
        return { ...previous, sortBy: sortPath, order, page: 1 }
      })
    }
  }
  return (
    <div
      className={styles.tableHeadWrapper}
      onClick={() => {
        setShowDropDown((previous) => {
          return !previous
        })
      }}
    >
      {name}
      <ArrowUpIcon className="text-[--primary-blue]" />
      {showDropDown ? (
        <div className={styles.filterDropdown}>
          <div data-order="1" className={styles.option} onClick={handleSorting}>
            A - Z
          </div>
          <div
            data-order="-1"
            onClick={handleSorting}
            className={styles.option}
          >
            Z - A
          </div>
          <div
            className={styles.option}
            data-name={name}
            onClick={(event) => {
              const filterName = event.currentTarget.getAttribute("data-name")

              setFilterToBeExpanded(filterName)
              setShowFilters(true)
            }}
          >
            Filter by
          </div>
        </div>
      ) : null}
    </div>
  )
}

export default PatientDetailsTableHeadCellCard
